/**
 * TopHypeContext – cached Set der Top-3-gehypten Release-IDs dieses Monats.
 * Wird einmal beim App-Start geladen und von ReleaseCard konsumiert.
 */
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const TopHypeContext = createContext(new Set());

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function TopHypeProvider({ children }) {
  const [topIds, setTopIds] = useState(new Set());

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/hype/top?limit=3`)
      .then(res => {
        const ids = new Set((res.data || []).map(r => r.id).filter(Boolean));
        setTopIds(ids);
      })
      .catch(() => {});
  }, []);

  return (
    <TopHypeContext.Provider value={topIds}>
      {children}
    </TopHypeContext.Provider>
  );
}

export function useTopHype() {
  return useContext(TopHypeContext);
}
